<template>
    <div style="height: 100%">
        <div class="sa-flexbox" style="padding-bottom: 20px">
            <div class="sa-flexbox-body">
                <div class="d-flex flex-column">
                    <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                        <b-col lg="3">
                            <p>Records Totali: {{ rows }}</p>
                        </b-col>
                        <b-col lg="9">
                            <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right"
                                size="sm"></b-pagination>
                        </b-col>
                    </b-row>
                </div>
                <div class="b-table-sticky-header">
                    <b-table v-if="items.length > 0" sticky-header ref="table" stacked="lg" striped hover :items="items"
                        :fields="fields" :current-page="currentPage" :per-page="perPage" :key="listKey" sort-icon-left
                        head-variant="light" class="sa-b-table">
                        <template #cell(statoAttuale)="row">
                            {{ row.item.statoAttuale }}
                            <div
                                style="min-width: 22px; height: 22px; display: flex; justify-content: center; align-items: center; border-radius: 50%; color: white; font-weight: 600; background-color: ">
                            </div>
                        </template>
                        <template #cell(ultimoAccesso)="row">
                            {{ getUltimoAccessoDataOra(row) }}

                        </template>
                        <template #cell(assistito)="row">
                            <span>{{ row.item.accettazione.accettazioneAnagrafica.cognome }} {{
                                row.item.accettazione.accettazioneAnagrafica.nome }}</span>
                            <br />
                            <small>{{ row.item.accettazione.accettazioneAnagrafica.identificativo }}</small>
                        </template>

                        <template #cell(actions)="row">
                            <b-button size="sm" v-b-tooltip.hover title="Prestazioni" variant="outline-primary"
                                @click="toggleRiga(row)">
                                <font-awesome-icon :icon="isAperto(row.item.id) ? 'arrow-down' : 'arrow-left'" />
                            </b-button>
                            <b-button size="sm" class="mr-1 ml-1 no-text" variant="outline-secondary  waves-effect "
                                @click="onClickOpenDetailAccettazione(row.item)">
                                <i class="bi bi-eye"></i>
                            </b-button>
                            <b-button size="sm" variant="btn btn-primary waves-effect  waves-light width-sm no-text"
                                @click="onClickApriCartellaPazienze(row)" style="margin-right: 3px">
                                <i class="bi bi-file-person"></i>
                            </b-button>

                            <b-button size="sm" variant="btn btn-purple waves-effect  waves-light width-sm no-text"
                                @click="onClickStampaAccettazione(row)" style="margin-right: 3px">
                                <b-icon icon="printer"></b-icon>
                            </b-button>

                            <!-- @click="onPrintPreview(row.item)" -->
                            <b-button size="sm"
                                variant="btn btn-secondary outline-secondary waves-effect  waves-light width-sm no-text"
                                @click="onClickAnteprimaRegistroPresenzaStampa(row.item)" style="margin-right: 3px">
                                <i class="bi bi-file-ruled"></i>
                            </b-button>

                            <!-- <print-component :jsonData="item" :linkPrintData="linkPrintData(item)" typeButton="small" :firmaGrafometrica="true"></print-component> -->
                        </template>
                        <template #row-details="row">
                            <b-collapse :visible="isAperto(row.item.id)" :id="'collapse-' + row.item.id">
                                <div class="ft-ricette">
                                    <accettazione-ssn-ricetta-dettaglio-component v-for="ricetta in listaRicetteDetails[row.item.id] || []"
                                        :key="ricetta.id" :ricetta="ricetta" />
                                    <div v-if="(listaRicetteDetails[row.item.id] || []).length == 0" class="ft-vuoto">
                                        Nessuna ricetta associata</div>
                                </div>
                            </b-collapse>
                        </template>
                    </b-table>
                    <NoDataComponent v-else ref="cmpNoDataComponent" title="Non sono presenti accettazioni"
                        nome="no-data" subtitle="" icon="fas fa-users" />
                </div>
            </div>
            <div class="d-flex flex-column">
                <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col lg="3">
                        <p>Records Totali: {{ rows }} {{ completeBookingSsn }}</p>
                    </b-col>
                    <b-col lg="9">
                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right"
                            size="sm"></b-pagination>
                    </b-col>
                </b-row>
            </div>
            <pdf-print-view-embedded ref="pdfPrintViewEmbedded" :pdf="signedPdfViewer"></pdf-print-view-embedded>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import NoDataComponent from "../../../../template/components/utility/NoDataComponent.vue";
// import PrintComponent from "../../../utility/components/PdfPrintViewEmbedded.vue";
import UtilityMixin from "../../../utility/UtilityMixin.js";
import PdfPrintViewEmbedded from "../../../utility/components/PdfPrintViewEmbedded.vue";
import AccettazioneSsnRicettaDettaglioComponent from "./AccettazioneSsnRicettaDettaglioComponent.vue";
// import PrintComponent from "../../../utility/components/PrintComponent.vue";

import moment from "moment";

export default {
    //PrintComponent
    mixins: [UtilityMixin],
    components: { PdfPrintViewEmbedded, NoDataComponent, AccettazioneSsnRicettaDettaglioComponent },
    data() {
        return {
            pathResource: "/accettazionessn",
            pathResourceRicette: "/accettazionericette",
            tipologiaAccettazioneConfig: this.appConfig.tipologieRicettaAccettazioneSSN,
            completeAccettazioneSsn: this.appConfig.completeAccettazioneSSN,
            internalAccettazioneSearchCf: this.appConfig.internalAccettazioneSearchCf,
            gestioneConsensiSsn: this.appConfig.gestioneConsensiSsn,
            completeBookingSsn: this.appConfig.completeBookingSSN,
            items: [],
            righeAperte: [],
            rows: 0,
            filtro: {
                codiceFiscaleAssistito: null,
                idPresidio: null,
            },
            page: 1,
            perPage: 10000,
            signedPdfViewer: null,
            listKey: 0,
            previewSelected: null,
            currentPage: 1,
            rowSelectedAccettazione: {},
            listaRicetteDetails: {},
            fields: [
                {
                    label: "C.F Assistito",
                    key: "assistito",
                },
                {
                    label: "Stato",
                    key: "statoAttuale",
                },

                {
                    label: "Data Ora Accettazione",
                    key: "createDate",
                    formatter: (param) => {
                        return UtilityMixin.methods.formatDateTime(param);
                    },
                },

                {
                    label: "Regime",
                    key: "regime",
                    class: "text-center",
                },
                {
                    label: "Gruppo",
                    key: "gruppo",
                    class: "text-center",
                },
                {
                    label: "Ricette",
                    key: "numeroRicette",
                    class: "text-center",
                },
                {
                    label: "",
                    key: "actions",
                    class: "sa-table-column-action-double",
                    thStyle: "width: 8rem",
                    thClass: "text-right",
                    tdClass: "text-right"
                }
            ],
        };
    },
    mounted() {
        if (!this.completeBookingSsn) {
            this.fields = this.fields.filter(e => e.key != 'gruppo')
        }
    },
    methods: {
        getOra(date) {
            return moment(date).format("HH:mm");
        },
        getFormatDate(date) {
            return moment(date).format("DD/mm/yyyy");
        },
        isAperto(id) {
            return this.righeAperte.includes(id);
        },
        toggleRiga(row) {
            const id = row.item.id;
            const index = this.righeAperte.indexOf(id);
            const dettaglioEsiste = this.listaRicetteDetails[row.item.id];
            if (index > -1 && dettaglioEsiste) {
                this.righeAperte.splice(index, 1);
            } else {
                let link = process.env.VUE_APP_PATH_API + this.pathResourceRicette;
                axios
                    .get(link, { params: { idAccettazione: row.item.id } })
                    .then((response) => {
                        this.listaRicetteDetails[row.item.id] = response.data.data.list;
                        this.righeAperte.push(id);
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            }
            row.toggleDetails();
        },
        gestisciApertura(item, index) {
            if (item) {
                this.$set(item, "isOpen", true);
                console.log(`Gruppo ${index} aperto`);
            }
            console.log(item);
        },
        gestisciChiusura(item, index) {
            console.log(item);

            if (item) {
                this.$set(item, "isOpen", false);
                console.log(`Gruppo ${index} chiuso`);
            }
        },
        loadData() {
            let me = this;
            me.$emit("beforeLoadData");
            me.items = [];
            let filtroStr = sessionStorage.getItem("filtroPageAccettazioneSsn");
            let filtroJson = JSON.parse(filtroStr);
            me.filtro = filtroJson;
            if (me.filtro != null) {
                me.filtro.page = me.currentPage;
                me.filtro.forPage = me.perPage;
            }

            UtilityMixin.methods.loadDataResources(me.pathResource, me.filtro, me.loadDataAccettazioneSsnSuccess, me.loadDataAccettazioneSsnError);
        },
        loadDataAccettazioneSsnSuccess(response) {
            let me = this;
            me.items = response.data.data.list;
            me.rows = response.data.data.recordsNumber;
            me.listKey++;
            me.$emit("afterLoadData");
        },
        loadDataAccettazioneSsnError(response) {
            let me = this;
            me.$emit("afterLoadData", response);
            console.log(response);

            me.$bvToast.toast(response.response.data.messaggio, {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },

        getTotalAppuntamentiEseguiti(prestazioni) {
            if (!prestazioni) return 0;
            return prestazioni.reduce((acc, p) => acc + (p.appuntamenti ? p.appuntamenti.filter(a => a.statoAttuale === 'ESEGUITO').length : 0), 0);
        },
        getTotalQuantitaErogabile(ricetta) {
            return ricetta.quantitaErogabile;
        },
        getUltimoAccessoDataOra(row) {
            console.log(row.item);


        },
        linkPrintData(item) {
            let returnValue = "/printer/" + item.id;
            return returnValue;
        },
        onClickOpenDetailAccettazione(accettazione) {
            this.$router.push("accettazionessn/" + accettazione.id);
        },
        // onClickDettaglio(row) {
        //   if (this.listaRicetteDetails[row.item.id]) {
        //     row.toggleDetails();
        //   } else {
        //     this.loadRicetteByAccettazione(row);
        //   }
        // },
        onClickStampaAccettazione(row) {
            let link = process.env.VUE_APP_PATH_API + "/accettazionessn/" + row.item.id;
            axios
                .get(link, { params: { idAccettazione: row.item.id } })
                .then((response) => {
                    console.log(response);
                    let acce = response.data.data;
                    let print = {
                        reportName: "StampaPrestazioneAccettazione",
                        data: {
                            ...acce,
                        },
                    };
                    this.onPrintPreview(print);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        onClickApriCartellaPazienze(row) {
            if (row.item.idPaziente) {
                this.$router.push("/rsapaziente/view/" + row.item.id);
            }
        },
        loadRicetteByAccettazione(row) {
            let link = process.env.VUE_APP_PATH_API + this.pathResourceRicette;
            axios
                .get(link, { params: { idAccettazione: row.item.id } })
                .then((response) => {
                    this.listaRicetteDetails[row.item.id] = response.data.data.list;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        onClickAnteprimaRegistroPresenzaStampa(item) {
            let link = process.env.VUE_APP_PATH_API + "/accettazionessn/print";
            axios
                .get(link, { params: { idAccettazione: item.accettazione.id } })
                .then((response) => {
                    let print = {
                        reportName: "RegistroPresenze",
                        data: {
                            ...response.data.data,
                        },
                    };
                    this.onPrintPreview(print);
                })
                .catch((error) => {
                    console.log(error);
                });

            // let print = {
            //   reportName: "RegistroPresenze",
            //   data: {
            //     identificativo: identificativo,
            //     prestazioni: prestazioni,
            //   },
            // };
            // me.onPrintPreview(print);
        },
        onClickAnnulla() {
            let me = this;
            me.$refs.mdlPreviewStampa.hide();
        },
        onPrintPreview(item) {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + "/print/createreport";
            me.showModalLoading = true;
            axios
                .post(link, item)
                .then((response) => {
                    me.signedPdfViewer = "data:application/pdf;base64," + response.data.base64;

                    me.$refs.pdfPrintViewEmbedded.show();
                })
                .catch((error) => {
                    // me.$refs.mdlGenerazioneReportInCorso.hide();
                    me.showModalLoading = false;
                    let messaggio = error.response.data.messaggio ? error.response.data.messaggio : "Errore non gestito, Codice: " + error.response.status;
                    this.$bvModal
                        .msgBoxOk(messaggio, {
                            title: this.$i18n.t("ERROR!"),
                            size: "sm",
                            okVariant: "outline-danger",
                            headerClass: "sa-msg-header-danger",
                            footerClass: "p-2 border-top-0",
                            centered: true,
                        })
                        .then((value) => {
                            this.boxTwo = value;
                        })
                        .catch((err) => {
                            err;
                        });
                });
        },
    },
    watch: {
        // currentPage() {
        //   let me = this;
        //   me.loadData();
        // },
    },
};
</script>

<style scoped>
/*
 * Contenitore del dettaglio ricette; la card della ricetta è AccettazioneSsnRicettaDettaglioComponent.
 * I colori seguono il tema del cliente (public/css/<cliente>); i valori dopo la virgola sono di riserva.
 */
.ft-ricette {
    --ft-muted: #6c757d;
    --ft-bg-soft: #f7f9fb;
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 10px 12px;
    background: var(--ft-bg-soft);
    border-radius: 8px;
}

.ft-vuoto {
    font-size: 11px;
    font-style: italic;
    color: var(--ft-muted);
}
</style>
